import { render, staticRenderFns } from "./JobPost.vue?vue&type=template&id=0d5a9272&scoped=true&"
import script from "./JobPost.vue?vue&type=script&lang=js&"
export * from "./JobPost.vue?vue&type=script&lang=js&"
import style0 from "./JobPost.vue?vue&type=style&index=0&id=0d5a9272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5a9272",
  null
  
)

export default component.exports